import { AnnotationToolFeatureId } from './annotationToolEnums';

/**
 * Annotation Tool allowed apps configuration.
 * This defines which apps and features are available in the Annotation Tool sidebar.
 */
export const ANNOTATION_TOOL_ALLOWED_APPS: Array<{
  appId: string;
  appName: string;
  features?: Array<{ featureId: string }>;
  additionalItems?: Array<{ featureId: string }>;
  sectionTitleId?: string;
}> = [
  {
    appId: AnnotationToolFeatureId.annotationDashboard,
    appName: AnnotationToolFeatureId.annotationDashboard,
    sectionTitleId: 'annotation-tool', // Section title for "Annotation tool"
  },
  {
    appId: AnnotationToolFeatureId.annotationSupervisor,
    appName: AnnotationToolFeatureId.annotationSupervisor,
    sectionTitleId: 'annotation-tool', // Section title for "Annotation tool"
  },
  {
    appId: AnnotationToolFeatureId.annotation,
    appName: AnnotationToolFeatureId.annotation,
    sectionTitleId: 'annotation-tool', // Section title for "Annotation tool"
  },
  {
    appId: AnnotationToolFeatureId.adminProjects,
    appName: AnnotationToolFeatureId.adminProjects,
    sectionTitleId: 'annotation-tool', // Section title for "Annotation tool"
  },
  {
    appId: AnnotationToolFeatureId.metrics,
    appName: AnnotationToolFeatureId.metrics,
    sectionTitleId: 'annotation-tool', // Section title for "Annotation tool"
  },
];
